const MIN = 60_000;
const HOUR = 60 * MIN;

/** Nombre de jours calendaires (heure locale) entre `from` et `to` : 1 = le lendemain, quelle que soit l'heure. */
function calendarDays(from: Date, to: Date): number {
  const a = new Date(from.getFullYear(), from.getMonth(), from.getDate()).getTime();
  const b = new Date(to.getFullYear(), to.getMonth(), to.getDate()).getTime();
  return Math.round((b - a) / (24 * HOUR));
}

/**
 * Horodatage relatif court, au ton de la maquette : « il y a 2 h », « hier », « lun. », « dans 3 j », « demain ».
 * Passé : minutes, heures, hier, jour de la semaine (moins d'une semaine), puis date courte.
 */
export function relativeTime(at: Date, now: Date = new Date()): string {
  const diff = now.getTime() - at.getTime();
  const days = calendarDays(at, now); // > 0 : passé

  if (diff >= 0) {
    if (diff < MIN) return 'à l’instant';
    if (diff < HOUR) return `il y a ${Math.floor(diff / MIN)} min`;
    if (days === 0) return `il y a ${Math.floor(diff / HOUR)} h`;
    if (days === 1) return 'hier';
    if (days < 7) return at.toLocaleDateString('fr-FR', { weekday: 'short' });
    return at.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });
  }

  const ahead = -diff;
  if (ahead < HOUR) return `dans ${Math.max(1, Math.ceil(ahead / MIN))} min`;
  if (days === 0) return `dans ${Math.floor(ahead / HOUR)} h`;
  if (days === -1) return 'demain';
  if (days > -7) return `dans ${-days} j`;
  return at.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });
}

/** Pluriel français simple : « 1 note », « 6 notes ». */
export const count = (n: number, one: string, many = `${one}s`): string => `${n} ${n > 1 ? many : one}`;
